import { render } from "./ultrataskView.vue?vue&type=template&id=75cc6da0&scoped=true"
import script from "./ultrataskView.vue?vue&type=script&lang=js"
export * from "./ultrataskView.vue?vue&type=script&lang=js"

import "./ultrataskView.vue?vue&type=style&index=0&id=75cc6da0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75cc6da0"]])

export default __exports__